import { Injectable } from '@angular/core';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor() {}

  // Manipulação de erros
  handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `mensagem: ${error.message}`;

      // if (error.status == 401) {
      //   //Desloga usuário
      //   sessionStorage.removeItem('token');
      //   window.location.href = '/';
      // }
    }
    return throwError(() => new Error(errorMessage));
  }

  addHeaderToken(): { headers: HttpHeaders } {
    let headerDict;

    if(sessionStorage.getItem('token')){
      let token:string = JSON.parse(sessionStorage.getItem('token') + '').token;
      headerDict = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Headers': 'Content-Type',
        Authorization: `Bearer ${token}`,
        'Authorization-Type': 'JwtAuthorization',
      };
    }
    else{
      headerDict = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Authorization-Type': 'JwtAuthorization',
      };
    }
     
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return requestOptions;
  }

  addHeaderFileToken(): { headers: HttpHeaders } {
    const token: string = JSON.parse(sessionStorage.getItem('token') + '').token;

    const headerDict = {
      // 'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      Authorization: `Bearer ${token}`,
      'Authorization-Type': 'JwtAdminAuthorization',
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return requestOptions;
  }
}
